import Products from '../../Products/Products'


const RelatedProducts = () => {
    return <div className='related-product'>
        <Products headingText="Related Products" />
    </div>;
};

export default RelatedProducts;
